window.$b = $('body');
window.$w = $(window);
window.breakpoints = {
	xs: 0,
	md: 768,
	lg: 1025,
	xl: 1536
};